// After a successful login on /login, darken the room and hold Turbo's
// render of the next page until the fade has finished. A failed login
// (422/429) renders normally, so the error flicker shows straight away.
export function installEntranceExit(root = document, delay = 600) {
  let leaving = false

  function onFetchResponse(event) {
    const form = event.target
    if (!(form instanceof Element) || !form.matches('.entrance__form')) return
    if (!event.detail?.fetchResponse?.succeeded) return

    form.closest('[data-entrance]')?.classList.add('entrance--leaving')
    leaving = true
  }

  function onBeforeRender(event) {
    if (!leaving) return
    leaving = false
    event.preventDefault()
    setTimeout(() => event.detail.resume(), delay)
  }

  root.addEventListener('turbo:before-fetch-response', onFetchResponse)
  root.addEventListener('turbo:before-render', onBeforeRender)

  return () => {
    root.removeEventListener('turbo:before-fetch-response', onFetchResponse)
    root.removeEventListener('turbo:before-render', onBeforeRender)
  }
}
